import axios from "axios";
import * as config from '../../config/envConfig';
import { isRelocationDateAfterNewChanges } from "../utilities";
import loginApi from "./loginApi";
import { getActiveAccount } from "../Authentication/MSALHelperMethods";

const contentTypes = {
  json: "application/json"
};

const responseTypes = {
  json: "json"
};
const func = [
  function (data) {
    return data;
  }
];

// API request encapsulation
const request = async (path,
  method,
  data,
  cType,
  rType,
  anotherPath,
  header) => {
  const contentType = (cType === undefined || cType === null) ? contentTypes.json : cType;
  const responseType = (rType === undefined || rType === null) ? responseTypes.json : rType;
  const httpMethod = method || "get";
  let utoken = await getUserToken();
  const headerConfig =
    header === undefined
      ? { Authorization: `Bearer ${utoken}` }
      : { "Auth-Token": `${utoken}` };
  return await axios({
    method: httpMethod,
    data,
    url: anotherPath === undefined ? config.PROXY_URL + path : path,
    headers: {
      "Content-Type": `${contentType}`,
      ...headerConfig
    },
    responseType: responseType,
    transformRequest: anotherPath ? func : null
  })
    .then(result => {
      return result.data;
    })
    .catch(error => {
      if (error.response) {
        throw error.response.data;
      } else {
        throw error.message;
      }
    });
};

function getUrl(BasicUrl, path, endpoint) {
  if (endpoint) {
    return path;
  }
  return `${BasicUrl}${path}`;
}

const getFormData = object => {
  if (typeof (FormData) === undefined) {
    const data = [];
    Object.keys(object).forEach(key => {
      Object.values(object).forEach(val => {
        data.push(key, JSON.stringify(val));
      });
    });
    return data;
  } else {
    return Object.keys(object).reduce((formData, key) => {
      formData.append(key, object[key]);
      return formData;
    }, new FormData());
  }
};
/**
 *
 * @param {string} targetValue
 * @param {string} targetValue
 */
// get the qas data
const getAddress = targetValue => {
  const uri = config.QAS;
  const requestData =
  {
    "qasType": "search",
    "search": targetValue
  }
  return request(
    uri,
    "post",
    JSON.stringify(requestData),
    undefined,
    undefined,
    true
  ).then(PicklistEntry => {
    const results = PicklistEntry.qaSearchResult.qaPicklist.picklistEntry;
    const PartialAddress = results[0].moniker === ""
      ? results[0].picklist
      : results.map(address => address.partialAddress)
    return { PicklistEntry: results, PartialAddress: PartialAddress }
  }).catch(err => {
  })
};

const getBsbDetails = (value) => {
  const url = "api/ReferenceDataService/RetrieveBSBDetails";
  const content = { BSBNumber: value };
  return request(url, "post", content).then(res => {
    if (res.Successful) {
      return {
        bsbName: res.BSBLookUpDetails[0].BranchName,
        bankName: res.BSBLookUpDetails[0].BankName,
        isSuccessful: res.Successful
      };
    } else {
      return {
        isSuccessful: res.Successful
      }
    }
  });
}

/**
 * Get or refresh the current user's access token
 * @returns User access token
 */
const getUserToken = async () => {
  let refresh_token = sessionStorage.getItem("refresh_token");
  let isExpired = loginApi.checkIsExpiredToken();
  let isRefreshToken = refresh_token !== null && refresh_token !== undefined && refresh_token !== "" && refresh_token !== "undefined";
  let msalAccount = getActiveAccount();
  let msalAccountExists = msalAccount !== null && msalAccount !== undefined;

  // if the user's access token has expired
  if (isExpired) {
    // if the user has logged in via MSAL method
    if (!isRefreshToken && msalAccountExists) {
      await loginApi.handleMSALRefreshToken();
    
    // if the user has not logged in via MSAL and has a refresh token
    } else {
      loginApi.handleNonMSALRefreshToken(refresh_token);
    }
  }

  return sessionStorage.getItem("login_access_token");
};

const isNewAfrByRequiredDate = async () => {
  const relocationPlanID = sessionStorage.getItem('RelocationPlanId');
  const url = `api/OrderDetailService/RetrieveRelocationPlanRelocationDetails`;
  const content = { "Id": relocationPlanID };

  const res = await request(url, "post", content);
  if (res.Successful) {
    const relocationRequiredDate = new Date(res.RelocationDetails.RelocationRequiredDate);
    //separation
    const relocationSeparation = res.RelocationDetails.ReasonForRelocationSubTypeDescription;
    const isNewAfr = isRelocationDateAfterNewChanges(relocationRequiredDate);
    if (relocationSeparation.toLowerCase() === 'separation') {
      return { isNewAfrSep: true, isNewAfr: false };
    }
    return { isNewAfr: isNewAfr, isNewAfrSep: false };
  } else {
    return { isNewAfr: true, isNewAfrSep: false };
  }
}

export default {
  contentTypes,
  responseTypes,
  request,
  getUrl,
  getFormData,
  getAddress,
  getBsbDetails,
  getUserToken,
  isNewAfrByRequiredDate
};
